// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResultTile_root__EAOHV"};